export const formatNumber = (value, digits = 0) =>
  Number(value || 0).toLocaleString("en-US", { maximumFractionDigits: digits });

export const getChangeClass = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "bg-slate-100 text-slate-500";
  }
  return Number(value) >= 0
    ? "bg-emerald-100 text-emerald-600"
    : "bg-rose-100 text-rose-600";
};
